<template>
  <b-row align-h="center">
    <FITModal ref="editTeamAgentModal" reference="modal" :title="modalParams.modalTitle" @click="onClickModal">
      <div slot="body">
        <span v-html="modalParams.modalContent">
        </span>
      </div>
    </FITModal>
    <div class="w-75">
      <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
      <FITFormCard>
        <div slot="header">
          <b-row>
            <b-col>
              <h4>{{formHeader}}</h4>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="8">
              <FITAutoSearch field="leader" :rule="{required:true}" :label="$t('adm.team.leader')" :width="8" v-model="leader" dest="option" v-bind="agentAutoSearchParams"></FITAutoSearch>
              <FITTextInput field="teamCode" :rule="{required:true,policy:true}" :label="$t('adm.team.teamCode')" :width="8" v-model="teamCode"></FITTextInput>
              <b-row>
                <b-col offset="4">
                  <FITCheckbox :label="$t('adm.team.haveParentTeam')" trueString="Y" falseString="N" v-model="haveParentTeam"></FITCheckbox>
                </b-col>
              </b-row>
              <FITAutoSearch field="parentTeam" :rule="{required:true}" v-if="haveParentTeam == 'Y'" :label="$t('adm.team.parentTeam')" :width="8" v-model="parentTeam" dest="option" v-bind="teamAutoSearchParams"></FITAutoSearch>
              <FITButton size="md" variant="primary" :text="$t('general.submit')" @click="validationCheck"></FITButton>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <FITFormCard v-if="isExistTeam">
        <div slot="header">
          <b-row>
            <b-col>
              <h4>{{$t('adm.agent.header')}}</h4>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="8">
              <template v-for="(member,index) in teamMembers">
                <b-row align-v="center">
                  <b-col cols="2" offset="2">{{index+1}}.</b-col>
                  <b-col cols="6">
                    <FITAutoSearch :rule="{required:true}" @validation="setValidationResult($event)" vuexObject="assignAgent" :width="8" v-model="teamMembers[index]" dest="option" v-bind="agentAutoSearchParams" :disabled="teamMemberDisabled[index]"></FITAutoSearch>
                  </b-col>
                  <b-col cols="1">
                    <FITButton v-if="!member.isExist" :text="$t('general.add')" variant="primary" @click="onClickAssignAgent(index)"></FITButton>
                    <FITButton v-else :text="$t('general.remove')" variant="danger" @click="onClickResignAgent(index)"></FITButton>
                  </b-col>
                  <b-col cols="1">
                  </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
    </div>
  </b-row>
</template>
<script type="text/javascript">
import { FITTextInput, FITSelect, FITFormCard, FITAutoSearch, FITCheckbox, FITButton, FITModal, FITAlert,FITValidationBus } from '@/components'
import Vue from 'vue';
import {mapState} from 'vuex'
export default {
  name: 'TeamCreate',
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    if (this.detail) {
      Vue.set(this, 'isExistTeam', true);
      this.$store.dispatch('Adm/getTeamDetail', this.detail.ID).then((json) => {
        var memberList = json.data.agent;
        memberList.forEach((item) => {
          item.isExist = true;
          item.englishFullname = item.agentEnglishName;
          item.chineseFullname = item.agentChineseName;
        })
        memberList.push({
          ID: 0,
          chineseFullname: '',
          englishFullname: '',
        });
        Vue.set(this, 'teamMembers', memberList)
        this.resetTeamMemberDisabaled();

      }, (err) => {

      })
      Vue.set(this, 'leader', {
        ID: this.detail.leaderID,
        agentCode: this.detail.agentCode,
        chineseFullname: this.detail.leaderChineseName,
        englishFullname: this.detail.leaderEnglishName
      })
      Vue.set(this, 'teamCode', this.detail.teamCode);
      if (this.detail.parentTeam) {
        Vue.set(this, 'parentTeam', {
          ID: this.detail.parentTeam,
          // teamCode: this.detail.pa
        })
      }
      Vue.set(this, 'teamID', this.detail.ID)
    }

    FITValidationBus.$emit('reset',true);
    this.$store.commit('Validation/validationReset');
    this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });

  },
  methods: {
    resetTeamMemberDisabaled(){
      let length = this.teamMembers.length;
      for (var i = length - 1; i >= 0; i--) {
        if(i == length -1){
           this.teamMemberDisabled[i] = false;
        }else{
          this.teamMemberDisabled[i] = true;
        }
      }
    },
    setValidationResult(event){
      // console.log(event);
      this.validation.assignAgent = event;
    },
    validationCheck(){
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },
    submit() {
      var params = {
        leaderID: this.leader.ID,
        teamCode: this.teamCode,
        parentTeamID: null
      }
      if (this.parentTeam) {
        params.parentTeamID = this.parentTeam.ID;
      }
      if (this.isExistTeam) {
        params.ID = this.teamID
        params.version = this.version
      }

      if (this.isExistTeam) {
        this.$store.dispatch('Adm/editTeam', params).then((json) => {
          Vue.set(this, 'isExistTeam', true);
          this.showSuccessAlert();

        }, (err) => {
          this.showErrorAlert();
        })
      } else {
        this.$store.dispatch('Adm/createTeam', params).then((json) => {
          Vue.set(this, 'isExistTeam', true);
          Vue.set(this, 'teamID', json.data.ID);
          Vue.set(this, 'version', json.data.version)
          this.showSuccessAlert();

        }, (err) => {
          this.showErrorAlert();
        })
      }

    },
    onClickAssignAgent(index) {
      FITValidationBus.$emit('dirty','assignAgent');
      if(!this.validation.assignAgent)
        return -1;
      Vue.set(this.modalParams, 'action', 'add');
      Vue.set(this.modalParams, 'modalTitle', this.$t('adm.team.addAgent'));
      Vue.set(this.modalParams, 'modalContent', this.$t('adm.team.addAgentComfirm', { agentName: this.teamMembers[index].englishFullname + ' ' + this.teamMembers[index].chineseFullname }));
      Vue.set(this, 'selectedAgent', index);

      this.$refs.editTeamAgentModal.openModal();
    },
    onClickResignAgent(index) {
      Vue.set(this.modalParams, 'action', 'remove');
      Vue.set(this.modalParams, 'modalTitle', this.$t('adm.team.removeAgent'));
      Vue.set(this.modalParams, 'modalContent', this.$t('adm.team.removeAgentComfirm', { agentName: this.teamMembers[index].englishFullname + ' ' + this.teamMembers[index].chineseFullname }));
      Vue.set(this, 'selectedAgent', index);
      this.$refs.editTeamAgentModal.openModal();
    },
    onClickModal(evt) {
      if (!evt) {
        return;
      }
      switch (this.modalParams.action) {
        case 'add':
          var params = {
            agentID: this.teamMembers[this.selectedAgent].ID,
            teamID: this.teamID
          }
          this.$store.dispatch('Adm/assignAgent', params).then((json) => {
            Vue.set(this.teamMembers[this.selectedAgent], 'isExist', true);
            this.teamMembers.push({
              ID: 0,
              chineseFullname: '',
              englishFullname: '',
            });
            this.resetTeamMemberDisabaled();
            this.showSuccessAlert();
            FITValidationBus.$emit('reset',true);
          }, (err) => {
            this.showErrorAlert();
          })
          break;
        case 'remove':
          var params = {
            agentID: this.teamMembers[this.selectedAgent].ID,
            teamID: this.teamID
          }
          this.$store.dispatch('Adm/resignAgent', params).then((json) => {
            this.teamMembers.splice(this.selectedAgent, 1);
            this.resetTeamMemberDisabaled();
            this.showSuccessAlert();
            FITValidationBus.$emit('reset',true);
          }, (err) => {
            this.showErrorAlert();
          })

          break;
      }
    },
    showSuccessAlert() {
      Vue.set(this, 'alertParams', {
        content: '<strong>Update Success</strong>',
        variant: 'success'
      })
      this.$refs.alert.showAlert();
    },
    showErrorAlert() {
      Vue.set(this, 'alertParams', {
        content: '<strong>Failed to upload. Please try again</strong>',
        variant: 'danger'
      })
      this.$refs.alert.showAlert();
    }

  },
  computed: {
      ...mapState({
        'vuexFinalResult': state => state.Validation.validationFinalResult,
      }),
    formHeader() {
      if (this.isExistTeam) {
        return this.$t('adm.team.editTeam');
      }
      return this.$t('adm.team.createTeam');
    }
  },
  watch:{
    haveParentTeam(newData,oldData){
      this.$store.commit('Validation/validationReset');
      FITValidationBus.$emit('reset',true);
    },
    vuexFinalResult(newData,oldData){
       let result = newData;
       // console.log("Final Result: "+newData);
      if(result){
       this.submit();
       this.$store.commit('Validation/validationReset');
       FITValidationBus.$emit('reset',true);
      }
    }
  },
  data() {
    return {
      alertParams: {
        content: '<strong>Update Success</strong>',
        variant: 'success'
      },
      version: 1,
      isExistTeam: false,
      selectedAgent: 0,
      modalParams: {
        action: '',
        modalTitle: '',
        modalContent: '',
      },
      teamMembers: [{
        ID: 0,
        chineseFullname: '',
        englishFullname: '',
        isExist: false
      }],
      teamMemberDisabled:[
      false],
      teamID: 0,
      haveParentTeam: 'N',
      leader: null,
      parentTeam: null,
      teamCode: '',
      agentAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'agent' }],
        showItems: ['englishFullname', 'chineseFullname', 'agentCode'],
      },
      teamAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'team' }],
        showItems: ['teamCode'],
      },
      validation:{
        assignAgent:null,
      }
    }
  },
  components: {
    FITTextInput,
    FITSelect,
    FITAutoSearch,
    FITFormCard,
    FITCheckbox,
    FITButton,
    FITModal,
    FITAlert
  },
}

</script>



// WEBPACK FOOTER //
// src/Adm/Team/TeamCreate.vue